/* global ul_widget */
import { Turbo } from "@hotwired/turbo-rails";

Turbo.StreamActions.scroll_to = function () {
  const target = this.targetElements[0];
  target.scrollIntoView({ behavior: "smooth" });
};

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};

document.addEventListener("turbo:load", () => {
  if (window["ul_widget"] !== void 0 && document.getElementById("chatbot_script") != null) {
    ul_widget("init", { id: 341, lg_id: "", mode_spa: true });
  }
});

document.addEventListener("turbo:load", () => {
  if (window.WOVN && window.WOVN.io) {
    requestAnimationFrame(() => {
      window.WOVN.io.manualStart();
    });
  }
});

Turbo.StreamActions.gtm_tag = function () {
  const page_url = this.getAttribute("page_url");
  const page_title =
    this.getAttribute("page_title") || "LivePocket（ライブポケット）｜電子チケット予約・購入・イベント検索";
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "SPA_pageview",
    virtualPageUrl: page_url,
    virtualPageTitle: page_title,
  });
};
